import { render, staticRenderFns } from "./BaseSelectInput.vue?vue&type=template&id=4357d4af&scoped=true"
import script from "./BaseSelectInput.vue?vue&type=script&lang=js"
export * from "./BaseSelectInput.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectInput.vue?vue&type=style&index=0&id=4357d4af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4357d4af",
  null
  
)

export default component.exports